import { buildToStorage } from '../services/buildStorage';

export function aiDraftToSavedBuildPayload({ build, genConfig, name = '' }) {
    return {
        name,
        build: buildToStorage(build),
        genConfig: typeof genConfig?.toObject === 'function' ? genConfig.toObject() : {},
    };
}

